import { request } from '@umijs/max';

/** 任务列表 GET /robot/task/list */
export function getTaskList(
  data: API.PageParams & API.TASK.TaskSearch = {
    pageNum: 1,
    pageSize: 12,
  },
) {
  //@ts-nocheck
  const { pageNum, pageSize, ...searchQuery } = data;
  return request<API.ListResponse<API.TASK.Task>>('/robot/task/list', {
    method: 'GET',
    params: data,
  });
}

/** 任务详情 GET /robot/task/{taskId} */
export function getTaskDetail(taskId: number) {
  return request<API.CommonResponse<API.TASK.Task>>(`/robot/task/${taskId}`, {
    method: 'GET',
  });
}

/** 更新任务 PUT /robot/task/edit */
export function updateTask(data: Partial<API.TASK.Task>) {
  return request<API.CommonResponse<API.TASK.Task>>('/robot/task/edit', {
    method: 'PUT',
    data,
  });
}

/** 创建临时任务 GET /robot/task/addTemp */
export function createTemporaryTask(data: API.TASK.NewTask) {
  return request<API.CommonResponse<API.TASK.Task>>('/robot/task/addTemp', {
    method: 'PUT',
    data,
  });
}

/** 删除任务 DELETE /robot/task/{taskId} */
export function deleteTask(taskId: number) {
  return request<API.CommonResponse<API.TASK.Task>>(`/robot/task/${taskId}`, {
    method: 'DELETE',
  });
}

export const TASK_STATUS_MAP: Record<
  API.TASK.WorkStatus,
  { key: string; color: string; label: string }
> = {
  pending: {
    key: 'pending',
    color: 'orange',
    label: '待执行',
  },
  processing: {
    key: 'processing',
    color: 'processing',
    label: '执行中',
  },
  paused: {
    key: 'paused',
    color: 'warning',
    label: '暂停中',
  },
  completed: {
    key: 'completed',
    color: 'success',
    label: '已完成',
  },
  cancelled: {
    key: 'cancelled',
    color: 'default',
    label: '已取消',
  },
  failed: {
    key: 'failed',
    color: 'error',
    label: '失败',
  },
};
